import styled from 'styled-components';

// FolderList
export const FolderListContainer = styled.div`
	width: 100%;
	padding: 0px 20px 50px;
	margin-top: -10px;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 10px;
`;

export const OrderedButtonContainer = styled.ol`
	width: 100%;

	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
`;
export const OrderedButton = styled.button`
	border: none;
	background-color: transparent;

	padding: 4px 6px;
`;

export const FolderList = styled.div`
	width: 100%;

	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
	gap: 12px;
`;

export const FolderCreateButton = styled.button`
	width: 100%;
	height: 74px;
	padding: 12px;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 4px;

	border: 1px solid ${({ theme }) => theme['warmgray-300']};
	border-radius: 6px;
	background-color: white;
	cursor: pointer;

	svg {
		width: 24px;
		height: 24px;

		path {
			fill: ${({ theme }) => theme['orange-primary']};
		}
	}
`;

// Footer
export const Footer = styled.footer`
	padding: 20px;

	display: flex;
	flex-direction: column;
	gap: 8px;

	background-color: ${({ theme }) => theme['gray02-50']};
`;

export const FooterTerms = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 8px;
`;

export const FooterTitle = styled.div`
	width: 100%;

	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const FooterListItem = styled.ol`
	display: grid;
	grid-template-columns: 40% 60%;
`;
